import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  list: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  li: {
    display: 'flex',
    alignItems: 'center',
    '&:last-child div': {
      marginBottom: 0,
    },
  },
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 10,
  },
  column: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  title: {
    display: 'block',
    width: '50%',
    marginRight: 30,
    fontSize: 14,
    color: '#646464',
    [theme.breakpoints.down('sm')]: {
      marginRight: 20,
    },
  },
  value: {
    width: '50%',
    fontSize: 14,
    color: theme.custom.darkBlue,
    textAlign: 'right',
    wordBreak: 'break-word',
    justifyContent: 'flex-end',
  },
  alignLeft: {
    justifyContent: 'flex-start',
    textAlign: 'left',
  },
  alignCenter: {
    justifyContent: 'flex-center',
    textAlign: 'center',
  },
  alignRight: {
    justifyContent: 'flex-end',
    textAlign: 'right',
  },
  icon: {
    color: theme.custom.warning,
  },
  html: {
    width: '50%',
    fontSize: 14,
    color: theme.custom.darkBlue,
    wordBreak: 'break-word',
    overflow: 'hidden',
    // '& > ol, & > ul': {
    //   marginLeft: 0,
    //   paddingLeft: 15,
    // },
    '& > *': {
      margin: 0,
      marginBottom: 7,
    },
  },
  tooltip: {
    background: theme.custom.warning,
  },
  tooltipWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: 13,
    fontFamily: 'NeoSansStd',
  },
  tooltipLink: {
    display: 'block',
    marginTop: 5,
    fontSize: 13,
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    color: '#fff',
    textAlign: 'center',
  },
  tooltipText: {
    textAlign: 'center',
  },
  groupTitleWrapper: {
    marginTop: 15,
    marginBottom: 10,
  },
  groupTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: '#224060',
  },
  btn: {
    minWidth: 'auto',
    marginRight: 10,
    padding: 3,
    borderRadius: '50%',
    background: 'transparent',
  },
  popper: {
    pointerEvents: 'all',
  },
  fullWidth: {
    width: '100%',
  },
}));
